function getFirstMondayInCalendar(firstDayOfMonth: Date) {
  while (firstDayOfMonth.getDay() !== 1) {
    firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 1);
  }
  return firstDayOfMonth;
}

function getNextDay(date: Date) {
  const newDate = new Date(date.getTime());
  newDate.setDate(date.getDate() + 1);
  return newDate;
}

export function getCalendarDates(
  year: number, month: number, numberOfDays: number,
): Date[] {
  const result: Date[] = [];

  let currentDate = getFirstMondayInCalendar(new Date(year, month, 1));

  for (let i = 0; i < numberOfDays; i++) {
    result.push(currentDate);
    currentDate = getNextDay(currentDate);
  }

  return result;
}

export interface CalendarEntry {
  date: Date;
  puzzleAvailable: boolean;
  currentMonth: boolean;
}

export function getCalendarEntries(year: number, month: number): CalendarEntry[] {
  return getCalendarDates(year, month, 6 * 7).map((date) => ({
    date,
    currentMonth: date.getMonth() === month,
    puzzleAvailable: date.getTime() < Date.now(),
  }));
}
